import { Component, ElementRef, OnInit, OnDestroy, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from "ngx-spinner";
import { ChatGPTService } from 'src/app/services/chat-gpt.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-openai-template',
  templateUrl: './modal-openai-template.component.html',
  styleUrls: ['./modal-openai-template.component.scss']
})
export class ModalOpenAITemplateComponent implements OnInit, OnDestroy {
  @Input() apenasLoading: boolean;
  data: any;
  selector: string;
  isLoading: boolean = true;
  newSubs: Subscription;
  textoSugerido: string;
  @Input() set carregando (valor) {
    if(!valor) {
      this.close();
    }
  }

  constructor(
    public activeModal: NgbActiveModal,
    private elemRef: ElementRef,
    public translate: TranslateService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private chatGPTService: ChatGPTService
  ) {
    this.selector = this.elemRef.nativeElement.tagName.toLowerCase();
    this.spinner.hide();
    this.spinner.show('spinner-ai');
  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]['style']['zoom'] = '0.85';

    if(!this.apenasLoading) {
      this.textoSugerido = this.data.texto;
      this.getTextSuggestion();
    }
  }
  
  ngOnDestroy(): void {
    this.spinner.hide('spinner-ai');
    this.newSubs?.unsubscribe();
  }

  close(action?: string) {
    let result = {};
    result['action'] = action;
    result['textoSugerido'] = this.textoSugerido;
    this.spinner.hide('spinner-ai');
    this.activeModal.close(result);
  }

  getTextSuggestion(): void {
    let texto = this.removeFigureTags(this.data.texto);
    let imagem = this.getContentInsideFigureTags(this.data.texto);
    if(texto) {
      this.newSubs = this.chatGPTService.getChatGPTCommentSuggestionModal(this.data.chamado_id, texto)
        .subscribe(
          (results) => {
            this.textoSugerido = results.sugestao + imagem;
            this.isLoading = false;
            this.spinner.hide('spinner-ai');
          }, (error) => {
            this.spinner.hide('spinner-ai');
            this.activeModal.close();
          }
        )
    } else {
      this.spinner.hide('spinner-ai');
      this.close('nao_corrigir');
    }
  }

  private removeFigureTags(input: string): string {
    const regex = /<figure class="image">.*?<\/figure>/gs;
    const retorno = input.replace(regex, '');
    return this.removeFigureTagsDimensionada(retorno)
  } 

  private getContentInsideFigureTags(input: string): string[] {
    const regex = /<figure class="image">(.*?)<\/figure>/gs;
    const matches = input.match(regex);
    const retorno: any =  matches ? matches.map(match => match.replace(/<\/?figure[^>]*>/g, '')) : [];
    return this.getContentInsideFigureTagsDimensionada(retorno === null ||retorno === undefined || retorno.length === 0 
      ? input 
      : retorno[0]);
  }

  private removeFigureTagsDimensionada(texto: string): string {
    const regex = /<img .*?>/g;
    return texto.replace(regex, '');
  } 

  private getContentInsideFigureTagsDimensionada(texto: string): string[] {
    const regex = /<img .*?>/g;
    const matches = texto.match(regex);
    return matches ? matches.map(match => match.replace(/<img >/g, '')) : [];
  }
}
